function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable jsx-a11y/label-has-for */
import PropTypes from 'prop-types';
import React, { Component, Children, isValidElement } from 'react';
import cx from 'classnames';
import Help from "../help";
import { uniqueId } from "../../utils/unique-id";
/**
 * @description: FormField is used to wrap form components like text inputs, selects,
 * and radio groups with consistent labeling and styling
 * */

var FormField =
/*#__PURE__*/
function (_Component) {
  _inherits(FormField, _Component);

  function FormField() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, FormField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(FormField)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "getChildOrSingleChild", function () {
      var children = _this.props.children;
      return Children.count(children) === 1 && Array.isArray(children) ? children[0] : children;
    });

    _defineProperty(_assertThisInitialized(_this), "renderHelp", function (help, childId) {
      if (!help) return;
      if (isValidElement(help)) return help;
      return React.createElement(Help, {
        message: help,
        id: "help-".concat(childId)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderRequired", function () {
      var isRequired = _this.props.isRequired;
      if (!isRequired) return;
      return React.createElement("span", {
        className: "FormField-required",
        role: "tooltip",
        title: "required"
      }, "*");
    });

    _defineProperty(_assertThisInitialized(_this), "renderLabel", function (childId, label, help) {
      if (!label) return null;
      return React.createElement("label", {
        htmlFor: childId,
        className: "FormField-label"
      }, label, _this.renderRequired(), _this.renderHelp(help, childId));
    });

    return _this;
  }

  _createClass(FormField, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.componentId = uniqueId();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          errorMessage = _this$props.errorMessage,
          help = _this$props.help,
          id = _this$props.id,
          label = _this$props.label,
          note = _this$props.note,
          labelAppendix = _this$props.labelAppendix;
      var child = Children.only(this.getChildOrSingleChild());
      var childId = "".concat(child.props.id || this.componentId);
      var containerClassName = cx({
        'form-group': true,
        'FormField-group-has-error': errorMessage
      }, className);
      return React.createElement("div", {
        id: id,
        className: containerClassName
      }, labelAppendix ? React.createElement("div", {
        className: "FormField-labelWrapper"
      }, this.renderLabel(childId, label, help), React.createElement("div", {
        className: "FormField-labelAppendix"
      }, labelAppendix)) : this.renderLabel(childId, label, help), React.cloneElement(child, {
        id: childId,
        className: cx('FormField-form-control', child.props.className)
      }), React.createElement("span", {
        className: "FormField-note"
      }, note), errorMessage ? React.createElement("span", {
        className: "FormField-errorMessage"
      }, errorMessage) : null);
    }
  }]);

  return FormField;
}(Component);

_defineProperty(FormField, "propTypes", {
  /**
   * The label of the form field, displayed above
   */
  label: PropTypes.string,

  /**
   * Helper text
   */
  help: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * Note, displayed in sub text font
   */
  note: PropTypes.string,

  /**
   * Error message
   */
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /**
   * className, applied to the container
   */
  className: PropTypes.string,

  /**
   * Custom id of the field
   */
  id: PropTypes.string,

  /**
   * isRequired field, marks the field with an asterisk
   */
  isRequired: PropTypes.bool,

  /**
   * Child component to render this FormField with: an input, textarea, etc.
   */
  children: PropTypes.node.isRequired,

  /**
   * Show appendix on the label
   */
  labelAppendix: PropTypes.node
});

export default FormField;